import {
   Table,
   TableHead,
   TableBody,
   TableRow,
   TableCell,
   TablePagination,
   Dialog,
   DialogContent,
   DialogContentText,
 } from "@mui/material";
 import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import React, { useCallback, useEffect, useState} from "react";
import NavBar from "../../components/navbar/navbar.component";
import SideBar from "../../components/sidebar/sidebar.component";
import { useDispatch, useSelector } from "react-redux"
import { 
  approveRider,
  getApprovedRiders,
  getCustomers,
  getRiderTemplate,
  importCustomer,
  postTopUp,
  downloadCustomer,
  getDiscounts,
  postDiscount,
  removeDiscount
} from "../../state/actions/rider.actions";
import Select from "react-select";
import {
  getApprovedPartners
} from "../../state/actions";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const DiscountMan = () => {

   const dispatch = useDispatch();
   const discounts = useSelector((state) => state.riders.discounts);
   const customers = useSelector((state) => state.riders.customers);
const isLoading = useSelector((state) => state.riders.status)

   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [addModal, setAddModal] = useState(false)
   const [searchParam, setSearchParam] = useState("")
   const [options, setOptions] = useState([]);
  const [customer, setCustomer] = useState(null);
  const [code, setCode] = useState(null);
  const [amount, setAmount] = useState(0);
  const [service, setService] = useState(1);
  const currentUser = JSON.parse(localStorage.getItem('user'));
  console.log("User", currentUser)

  const openAddModal = () => {
    setAddModal(true)
  }
  const closeAddModal = () => {
    setAddModal(false)
    setCustomer(null)
    setAmount(0)
    setService(1)
  }

   useEffect(() => {
    dispatch(getDiscounts()).then((res) => {
      console.log(res)
    });
    dispatch(getCustomers()).then((res) => {
          console.log(res)
          const custs = res.map((c) => ({
            label: c.companyName
              ? c.firstName + " " + c.lastName + " ( " + c.companyName + " )"
              : c.firstName + " " + c.lastName,
            value: c.id,
          }));
          const custSorted = custs.sort((a, b) => {
            const nameA = a.label?.toLowerCase();
            const nameB = b.label?.toLowerCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          setOptions(custSorted);
        });
   }, []);

   const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - discounts.length) : 0;

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

  const handleNameChange = (data) => {
    console.log("selected", data);
    setCustomer(data);
  };

  const handleAmountChange = (e) => {
    console.log("selected", e);
    const { value } = e.target;
    setAmount(value);
  };

  const handleCodeChange = (e) => {
    console.log("selected", e);
    const { value } = e.target;
    setCode(value);
  };

  const handleServiceChange = (e) => {
    console.log("selected", e);
    const { value } = e.target;
    setService(value);
  };

  const handleAdd = () => {
    var req = {customerId: customer.value, discount: amount, service: service, serviceCode: code}
    dispatch(postDiscount(req)).then(() => {
      dispatch(getDiscounts());
      closeAddModal();
    })
  }

  const handleRemove = (dis) => {
    var d = window.confirm("Are you sure you want to remove this item")
    if(d) {
      dispatch(removeDiscount(dis.id)).then(() => {
        dispatch(getDiscounts());
        closeAddModal();
      })
    }
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const search = (e) => {
    const { value } = e.target
    setSearchParam(value)
  }
  return (
    <>
      <NavBar />
      <SideBar />

      <div className="content-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">DIscounts</h4>
                  </div>
                  <div>
                    { currentUser.userType == 2 &&
                  <button
                    type="button"
                    className="btn btn-md btn-primary"
                    onClick={() => {
                      openAddModal();
                    }}
                  >
                    Add Discount
                  </button>}
                  </div>
                </div>
                <div className="card-body">
                  <div>
                    {isLoading === 'loading' ?
                    <div className="text-center">
                      <div className="spinner-border text-danger" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <p className="small">Getting Discounts...</p>
                    </div> :
                    discounts.length > 0 ? (
                      <>
                        <Box>
                          <div className="form-group">
                            <label className="form-label">Search</label>
                            <input type="text" onChange={search} className="form-control form-control-sm" />
                          </div>
                        </Box>
                        <Table ariaa-labelledby="tableTitle">
                          <TableHead>
                            <TableRow>
                              <TableCell>Company Name</TableCell>
                              <TableCell>Contact Name</TableCell>
                              <TableCell>Merchant No</TableCell>
                              <TableCell>Service</TableCell>
                              <TableCell>Service Code</TableCell>
                              <TableCell>Discount</TableCell>
                              { currentUser.userType == 2 && <TableCell></TableCell> }
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(rowsPerPage > 0
                              ? discounts.filter((c) => 
                                c.customer.companyName?.toLowerCase().includes(searchParam.toLowerCase()) ||
                                c.customer.firstName?.toLowerCase().includes(searchParam.toLowerCase()) ||
                                c.customer.lastName?.toLowerCase().includes(searchParam.toLowerCase())
                              ).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              : discounts.filter((c) => 
                                c.customer.companyName?.toLowerCase().includes(searchParam.toLowerCase()) ||
                                c.customer.firstName?.toLowerCase().includes(searchParam.toLowerCase()) ||
                                c.customer.lastName?.toLowerCase().includes(searchParam.toLowerCase())
                              )
                              ).map((approvedRider, index) => (
                                <TableRow hover tabindex={-1} key={index}>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{
                                      // width: "5% !important",
                                      padding: "0.5",
                                      margin: "0 !important",
                                    }}
                                  >
                                  {approvedRider.customer.companyName}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{
                                      // width: "5% !important",
                                      padding: "0.5",
                                      margin: "0 !important",
                                    }}
                                  >
                                  {approvedRider.customer.firstName} {approvedRider.customer.lastName}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{
                                      // width: "5% !important",
                                      padding: "0.5",
                                      margin: "0 !important",
                                    }}
                                  >
                                  { approvedRider.customer.customerAccount }
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{
                                      // width: "5% !important",
                                      padding: "0.5",
                                      margin: "0 !important",
                                    }}
                                  >
                                  { approvedRider.serviceName }
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{
                                      // width: "5% !important",
                                      padding: "0.5",
                                      margin: "0 !important",
                                    }}
                                  >
                                  { approvedRider.serviceCode }
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{
                                      // width: "5% !important",
                                      padding: "0.5",
                                      margin: "0 !important",
                                    }}
                                  >
                                  { approvedRider.discount }
                                  </TableCell>
                                  { currentUser.userType == 2 && <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{
                                      // width: "5% !important",
                                      padding: "0.5",
                                      margin: "0 !important",
                                    }}
                                  >
                                 <button type="button" className="btn btn-md btn-primary"
                                  onClick={() => { handleRemove(approvedRider); }}>
                                    Remove </button>
                                  </TableCell> }
                                </TableRow>
                              ))}
                            {emptyRows > 0 && (
                              <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={6} />
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </>
                    ) :
                    <div className="text-center">
                      <p>No Discount available</p>
                    </div>
                    }
                  </div>
                  <div>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, 50, { label: 'All', value: -1 }]}
                      component="div"
                      count={discounts.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: {
                          'aria-label': 'rows per page',
                        },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Import Dialog */}
      <Dialog
        open={addModal}
        onClose={closeAddModal}
        fullWidth={true}
        maxWidth="sm"
      >
        {/* <DialogTitle>Rider Details</DialogTitle> */}
        <DialogContent>
          <DialogContentText>
            <div className="modal-content">
              <div className="modal-header">
                <p
                  className="modal-title"
                  id="exampleModalCenteredScrollableTitle"
                >
                  Add Discount
                </p>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" onClick={closeAddModal}>
                    ×
                  </span>
                </button>
              </div>
              <div className="modal-body">
                
                <div>
                <div className="col-sm-12 d-flex pl-0 mb-2">
                <p style={{ fontSize: "14px" }}
                                className="col-6 col-sm-4 col-lg-5 col-xl-4 text mb-0"
                              >
                  Customer:
                              </p>
                              <Select
                                className="col-6 col-sm-7 col-xl-8 px-0"
                                options={options}
                                value={customer}
                                isSearchable={true}
                                isClearable={true}
                                onChange={handleNameChange}
                              />
                            </div>
                  <div class="col-sm-12 d-flex pl-0 mb-2">
                    <label for="partnerId" className="col-6 col-sm-4 col-lg-5 col-xl-4 text mb-0">Amount</label>
                    <select
                                className="form-control col-6 col-sm-7 col-xl-8 px-0"
                    value={service}
                    onChange={handleServiceChange}
                    >
                      <option value={0}>Same-Day</option>
                      <option value={1}>Schedule Delivery</option>
                    </select>
                  </div>
                  <div class="col-sm-12 d-flex pl-0 mb-2">
                    <label for="partnerId" className="col-6 col-sm-4 col-lg-5 col-xl-4 text mb-0">Discount</label>
                    <input class="form-control col-6 col-sm-7 col-xl-8 px-0" 
                    name="amount" 
                    id="amount" 
                    type="number" 
                    value={amount}
                    onChange={handleAmountChange}
                    />
                  </div>
                  <div class="col-sm-12 d-flex pl-0 mb-2">
                    <label for="code" className="col-6 col-sm-4 col-lg-5 col-xl-4 text mb-0">Service Code</label>
                    <input class="form-control col-6 col-sm-7 col-xl-8 px-0" 
                    name="code" 
                    id="code" 
                    type="text" 
                    value={code}
                    onChange={handleCodeChange}
                    />
                  </div>
                  <div>
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleAdd}
                      >
                        Add
                      </button>
                  </div>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <ToastContainer />
    </>
  );
};

export default DiscountMan;
